/**
 * This is the detault columns for Incidents
 * field - This is the property on the object that wil be displayed within this column
 * headerName - This is the header that will be displayed for the column
 * hideableable: This is a custom field that will determine whether a column will be able to be added to the grid or not (visibility) 
 */
export const incidentsColumns = [
    {
        field: 'number',
        headerName: 'Incident ID',
        showColumn: true,
        textConfig: {bold: true},
        preString: "#",
        filterType: 'text', // free-text / id search
        alertIcons: [
            {
                field: 'escalated',
                value: "True",
                icon: "emergency",
                placement: "post"
            },
            {
                field: 'emergency',
                value: "True",
                icon: "escalated",
                placement: "post"
            }
        ]
    }, {
        field: 'priority',
        headerName: 'Priority',
        cellType: 'chip',
        typeConfig: {colors: {"Low": "green", "Medium": "orange", "High": "red"}},
        showColumn: true,
        filterType: 'select', // multi-select
    }, {
        field: 'type',
        headerName: 'Incident Type',
        cellType: 'text',
        showColumn: true,
        filterType: 'select', // multi-select
    }, {
        field: 'category',
        headerName: 'Category Type',
        cellType: 'text',
        showColumn: true,
        filterType: 'select', // multi-select
    }, {
        field: 'perpetrator',
        headerName: 'Persons Involved',
        cellType: 'text',
        showColumn: true,
        filterType: 'text',
    }, {
        field: 'assignedUsersNames',
        headerName: 'Assignees',
        cellType: 'text',
        showColumn: true,
        filterType: 'text',
    }, {
        field: 'status',
        headerName: 'Status',
        cellType: 'chip',
        typeConfig: {
            colors: {
                "New": "green",
                "Open": "gray",
                "Investigate": "blue",
                "Waiting": "pink",
                "Closed": "darkGray",
                "Blocked": "yellow",
            }
        },
        showColumn: true,
        filterType: 'select', // multi-select
    }, {
        field: 'dateCreated',
        headerName: 'Created',
        cellType: 'hoursAgoDate',
        showColumn: true,
        filterType: 'date', // relative / range / exact
    }
];

// Top-level filters. NOTE (FEAT-031): Severity/Incident Type/Category/Person Involved/Status
// were REMOVED from here because they're now per-column, in-header filters on the table itself
// (multi-select). What remains is the **Assignee** picker — a server-side apiSelect that matches
// across ALL incidents (not just the loaded page), so it's not redundant with the loaded-rows
// column filters. The All/Open/Closed scope lives in `incidentsToggles` below.
export const getIncidentsFilters = async () => {
    return [
        {
            title: "District",
            field: "district",
            labelField: "districtName",
            type: "apiSelect",
            returnType: "string",
            permission: ["disclosureAdmin"],
            apiConfig: {
              apiBody: {},
              label: "District",
              dataType: "districts",
            },
        },
        {
            title: "School",
            field: "school",
            labelField: "schoolName",
            type: "apiSelect",
            returnType: "string",
            permission: ["disclosureAdmin", "districtAdmin"],
            apiConfig: {
              apiBody: {filters: [{ key: "district", value: "{district}", expression: "=", valueObj: "filterValues" }]},
              dataType: "schools",
              label: "School",
              requires: ["district"],
            },
        },
        {
            title: "Assignee",
            field: "assignedUsers",
            labelField: "assignedUsersName",
            type: "apiSelect",
            returnType: "string",
            multiple: true,
            apiConfig: {
              apiBody: {filters: [{ key: "permission", value: "responder", expression: "=",}]},
              dataType: "users",
              label: "Assignee",
              addedOptions: [{ id: "unassigned", label: "Unassigned" }],
            },
        },
    ]
}

export const incidentsToggles = {
    field: "status",
    options: ["All", "Open", "Closed"],
    active: ["All"],
    type: "string"
}